/**
 * 入札 CSV の確定時の再検証で取込全体が拒否されたときの理由メッセージを、
 * 確定モーダルのエラー表示向けに分解する (Des 回答 #8786、 spec
 * `spot-bid-block-csv-import.md` §5 / §6「確定時の再検証」)。
 *
 * backend は拒否理由を 1 行 1 件の改行区切りで返す (アップロード履歴の「詳細」に
 * 記録するのと同じ文言、 `FormatBidCsvRowErrors`)。 「行 N: 〜」(英語は `Row N: 〜`) で始まる行が行ごとの
 * エラー、 それ以外の行はファイル全体が理由 (手数料単価が Step2 から変わった等) で
 * 行番号を持たない。
 */

export type ConfirmRejection = {
  /** 行番号つきのエラー (backend が返した順)。 `text` は「行 N: …」の全文。 */
  rows: Array<{ text: string }>
  /** ファイル全体が理由の文言 (行番号なし)。 */
  fileReasons: string[]
}

// 日本語の「行 N: 」と英語の `Row N: ` (backend は取り込んだ人の表示言語で返す)。
const ROW_LINE = /^(?:行|Row) \d+: /

/**
 * 拒否メッセージを行ごとのエラーとファイル全体の理由に分ける。 原因の区分
 * (CSV を直すか時間をおくか) は業務判断なので frontend では決めない。
 */
export function parseConfirmRejection(message: string): ConfirmRejection {
  const lines = message
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '')
  const rows: ConfirmRejection['rows'] = []
  const fileReasons: string[] = []
  for (const line of lines) {
    if (ROW_LINE.test(line)) {
      rows.push({ text: line })
    } else {
      fileReasons.push(line)
    }
  }
  return { rows, fileReasons }
}
